import { useState, useEffect, useRef } from "react";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import useSelectStyles from "./Styles";

const LocationSelectGeoNames = ({
  onChange,
  value,
  placeholder,
  id,
  name,
  required,
  missingRequired,
  isDisabled,
  onKeyDown
}) => {

  // console.log('val@locsel', value)
  const animatedComponents = makeAnimated();

  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(null);
  const [isClient, setIsClient] = useState(false);

  const searchTimeout = useRef(null);

  // ensure SSR safe
  useEffect(() => setIsClient(true), []);

  // Fetch GeoNames suggestions based on user input
  useEffect(() => {
    if (!inputValue || inputValue.length < 3) return;

    if (searchTimeout.current) clearTimeout(searchTimeout.current);

    searchTimeout.current = setTimeout(async () => {
      try {
        const url = new URL("https://secure.geonames.org/searchJSON");
        url.searchParams.set("name_startsWith", inputValue);
        url.searchParams.set("featureClass", "P"); // P = populated place
        url.searchParams.set("maxRows", "10");
        url.searchParams.set("orderby", "population");
        url.searchParams.set("username", "ilias");

        const res = await fetch(url.toString());
        const json = await res.json();

        const newOptions = (json.geonames || []).map((g) => ({
          label: `${g.name}, ${g.adminName1 || ""}, ${g.countryName}`,
          value: g.geonameId,
          city: g.name,
          admin: g.adminName1,
          country: g.countryName,
          countryCode: g.countryCode,
          lat: Number(g.lat),
          lng: Number(g.lng)
        }));

        setOptions(newOptions);
      } catch (err) {
        console.error("GeoNames search error:", err);
        setError(err.message);
        setOptions([]);
      }
    }, 300); // debounce 300ms
  }, [inputValue]);

  if (!isClient) return null;

  return (
    <Select
      onKeyDown={onKeyDown}
      required={required}
      className={`w-full ${missingRequired ? "border border-red-400 dark:border-red-600" : ""} 
        dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
      classNamePrefix="select"
      isDisabled={isDisabled}
      isClearable
      isSearchable
      name={name}
      id={id}
      onChange={onChange}
      value={value}
      options={options}
      components={animatedComponents}
      placeholder={placeholder}
      noOptionsMessage={() => "Start typing in the city name..."}
      styles={useSelectStyles()}
      onInputChange={(val) => setInputValue(val)}
      filterOption={() => true} // server handles filtering
    />
  );
};

export default LocationSelectGeoNames;
























// import { useState, useEffect } from "react";
// import makeAnimated from "react-select/animated";
// import Select from "react-select";
// import citiesCA from "../../../json/geography/cities_CA";
// import citiesUS from "../../../json/geography/cities_US";
// import statesCA from "../../../json/geography/states_CA";
// import statesUS from "../../../json/geography/states_US";
// import countries from "../../../json/geography/countries_ALL";
// import { humanizeString } from "@/utils/frontend/stringOps";
// import useSelectStyles from "./Styles";

// const LocationSelectGeoNames = ({
//   onChange,
//   value,
//   placeholder,
//   id,
//   name,
//   required,
//   missingRequired,
//   zoomLevel,
//   selectedCountry,
//   selectedState,
//   isDisabled,
//   onKeyDown,
//   filterHasMarketplaceAccess=true
// }) => {
//   const animatedComponents = makeAnimated();

//   const [data, setData] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [error, setError] = useState(null);
//   const [isClient, setIsClient] = useState(false);


//     useEffect(() => {
//     setIsClient(true);
//     }, []);
//   // Populate states based on selected country
//   useEffect(() => {
//     if (!selectedCountry) return;

//     if (selectedCountry.toUpperCase() === "CANADA") {
//       setStates(statesCA);
//       setCities([]); // Reset cities when country changes
//     } else if (selectedCountry.toUpperCase() === "UNITED_STATES") {
//       setStates(statesUS);
//       setCities([]); // Reset cities when country changes
//     }
//   }, [selectedCountry]);

//   // Populate cities based on selected state
//   useEffect(() => {
//     if (!selectedState || !selectedCountry) return;

//     if (selectedCountry.toUpperCase() === "CANADA") {
//       // console.log("SELECTEDSTATE", selectedState)
//       setCities(citiesCA.filter(city => city.state?.toUpperCase().split(' ').join('_') === selectedState.toUpperCase().split(' ').join('_')));
//     } else if (selectedCountry.toUpperCase() === "UNITED_STATES") {
//       setCities(citiesUS.filter(city => city.state?.toUpperCase() === selectedState.toUpperCase()));
//     }
//   }, [selectedState, selectedCountry]);

//   // Populate dropdown options based on zoomLevel
//   useEffect(() => {
//     try {
//       let options = [];
//       if (zoomLevel === "COUNTRIES") {
//         // if only displaying has_marketplace_access country (countries that currently have access to job and talent marketplace)
//         countries = filterHasMarketplaceAccess === true ? countries.filter(c => c.has_marketplace_access===true) : countries
//         options = countries.map(country => ({
//           value: country.country,
//           label: humanizeString(country.country),
//         }));

//       } else if (zoomLevel === "STATES") {
//         options = states.map(state => ({
//           value: state.state,
//           label: humanizeString(state.state),
//         }));
//       } else if (zoomLevel === "CITIES") {
//         options = cities.map(city => ({
//           value: city.city,
//           label: city.city,
//         }));
//       }
//       setData(options);
//     } catch (error) {
//       setError(error.message);
//       setData([]);
//     }
//   }, [zoomLevel, states, cities]);

//     if (!isClient) {
//     return null; // or a fallback UI if desired
//   }
//   return (
//     <Select
//     onKeyDown={onKeyDown}
//       required={required}
//       className={`w-full ${
//         missingRequired && "border border-red-400 dark:border-red-600"
//       } dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
//       classNamePrefix="select"
//       isDisabled={isDisabled}
//       isClearable
//       isSearchable
//       name={name}
//       id={id}
//       onChange={onChange}
//       value={value}
//       options={data}
//       // components={animatedComponents}
//       placeholder={placeholder}
//       styles={useSelectStyles()}
//     />
//   );
// };

// export default LocationSelectGeoNames;